export const SALE_SOURCES_SET = 'SALE_SOURCES_SET';
